import { render, staticRenderFns } from "./detail-testPaper.vue?vue&type=template&id=0683783d&scoped=true&"
import script from "./detail-testPaper.vue?vue&type=script&lang=ts&"
export * from "./detail-testPaper.vue?vue&type=script&lang=ts&"
import style0 from "./detail-testPaper.vue?vue&type=style&index=0&id=0683783d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0683783d",
  null
  
)

export default component.exports